import FAQPage from "@components/faq-page";
import { loadTranslation } from "@lib/utils";
import { GetStaticProps } from "next";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  return { props: { translation, locale } };
};

const FAQ: React.FunctionComponent = () => {
  const router = useRouter();
  const locale = router.locale || router.defaultLocale;
  const seoLocale = "/" + locale;
  const title = t`FAQ - Lumi News`;
  const description = t`Need help? Read up on FAQs to get answers to your questions and use the Lumi News app like a pro.`;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: `https://luminews.my${
            seoLocale.includes("en") ? "" : seoLocale
          }${router.asPath}`,
          title: title,
          description: description,
        }}
      />
      <FAQPage />
    </>
  );
};

export default FAQ;
